import styled from 'styled-components';
import { Tabs } from 'antd';

export const DropoffTitle = styled.div`
  border-radius: 4px;
  border: 1px solid #b3c8ff;
  background: #f2f6ff;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  color: #1890ff;
  width: fit-content;
`;

export const TabsContainer = styled(Tabs)`
  margin-top: 16px;

  .gm-ant-tabs-nav {
    margin-left: 4px;
    margin-right: 4px;
  }
`;
